<template>
  <section class="w-full">
    <h1 class="flex items-center justify-between">
      Mulit-Mandanten Status
    </h1>
    <div class="flex flex-wrap w-full -mx-4">
      <div class="w-1/2 p-4">
        <div :class="`w-2/5 font-semibold text-gray-600 uppercase`">
          Status:
        </div>
        <div :class="`w-2/5`">
          <div>
            <span>{{ companyStateName }}</span>
          </div>
        </div>
      </div>
      <div class="w-1/2 p-4">
        <div :class="`w-2/5 font-semibold text-gray-600 uppercase`">
          Multi-Tenant Status:
        </div>
        <div :class="`w-2/5`">
          <div>
            <span v-if="isChildCompany">Mandant</span>
            <span v-else>Hauptfirma</span>
          </div>
        </div>
      </div>
      <div
        v-if="isChildCompany"
        class="w-1/2 p-4"
      >
        <div :class="`w-2/5 font-semibold text-gray-600 uppercase`">
          Link zur Muttergesellschaft:
        </div>
        <div
          v-if="currentRouteId !== company?.parentId"
          :class="`w-2/5`"
        >
          <div>
            <span
              class="link"
              @click="navigateToMaster"
            >{{ parentCompanyName }}</span>
          </div>
        </div>
        <div
          v-else
          class="text-gray-500"
        >
          Muttergesellschaft nicht verfügbar
        </div>
      </div>
      <template v-if="isParentCompany">
        <div class="w-1/2 p-4">
          <div :class="`w-2/5 font-semibold text-gray-600 uppercase`">
            Liste der Tochterunternehmen:
          </div>
          <table
            v-if="childCompanies?.length > 0"
            class="companies-table"
          >
            <thead>
              <tr>
                <th>Name / Slug</th>
                <th>Produkttyp</th>
                <th>Plattform</th>
                <th>Kundennummer</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="company in childCompanies"
                :key="company.id"
                class="clickable"
                @click="navigateToChildrenCompany(company.id)"
              >
                <td>{{ company.name || company.slug }}</td>
                <td>{{ company.productType }}</td>
                <td>{{ company.platform?.toUpperCase() }}</td>
                <td>{{ company.customerNumber }}</td>
              </tr>
            </tbody>
          </table>
          <span
            v-else
            class="text-gray-500"
          >Keine Tochterunternehmen</span>
        </div>
        <div class="w-1/2 p-4">
          <div :class="`w-2/5 font-semibold text-gray-600 uppercase`">
            Anzahl der Kunden:
          </div>
          <div :class="`w-2/5`">
            <div>
              <span>{{ childCompanies?.length ?? 0 }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
import CHILD_COMPANIES from '@/graphql/ChildCompanies.gql'
import { getCompanyStatesName } from '@/config'
import GET_COMPANY from '@/graphql/GetCompany.gql'

export default {
  props: {
    company: { type: Object, required: true }
  },
  data () {
    return {
      childCompanies: [],
      parentCompanyName: null
    }
  },
  computed: {
    currentRouteId () {
      return this.$route.params.id
    },
    state () {
      const last = (list) => list[list.length - 1]
      return last(this.company?.state?.stringValues)
    },
    companyStateName () {
      return getCompanyStatesName(this.state) || this.state
    },
    isChildCompany () {
      return !!this.company?.parentId
    },
    isParentCompany () {
      return !this.company?.parentId
    }
  },
  methods: {
    navigateToChildrenCompany (companyId) {
      this.$router.push(`/companies/${companyId}`)
    },
    navigateToMaster () {
      this.$router.push(`/companies/${this.company?.parentId}`)
    }
  },
  apollo: {
    getParentCompany: {
      query: GET_COMPANY,
      variables () {
        return { id: this.company?.parentId }
      },
      skip () {
        return this.isParentCompany
      },
      update (data) {
        if (data && data.company) {
          this.parentCompanyName = data.company.name ?? data.company.slug
        }
      }
    },
    childCompanies: {
      query: CHILD_COMPANIES,
      variables () {
        return { parentId: this.company?.id }
      },
      skip () {
        return !this.isParentCompany
      }
    }

  }
}
</script>

<style scoped>
.link {
    color: #3b82f6;
    cursor: pointer;
    text-decoration: underline;
}
.companies-table {
  width: 100%;
  border-collapse: collapse;
}
.companies-table th,
.companies-table td {
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
}
.companies-table th {
  background: #f9fafb;
  text-align: left;
  font-weight: 600;
  color: #374151;
}
.clickable { cursor: pointer; }
.clickable:hover { background: #f3f4f6; }

</style>
